// Leading vowels (accented included) and mute h take "de l'" instead of "du";
// job titles starting with an aspirated h keep "du" ("du Handballeur").
// Same rule and list in company, app, app.admin and app-mobile-interim.
const VOWEL_START = /^[aeiouàâäéèêëîïôöùûüœæ]/;
const ASPIRATED_H_PREFIXES = [
  'hach',
  'haie',
  'hall',
  'hand',
  'hang',
  'hard',
  'harn',
  'hau',
  'hock',
  'homard',
  'hors',
  'hou',
  'hub',
  'huit',
  'hurl',
];

export const needsElision = (title) => {
  const word = String(title ?? '').trim().toLowerCase();
  if (VOWEL_START.test(word)) return true;
  if (!word.startsWith('h')) return false;
  return !ASPIRATED_H_PREFIXES.some((prefix) => word.startsWith(prefix));
};

/**
 * Heading of the tasks section: "Tâches du Cariste H/F",
 * "Tâches de l'Agent de quai H/F". Templates come from the locales.
 */
export const missionTasksHeading = (title, { titleDe, titleElided }) => {
  const cleanTitle = String(title ?? '').trim();
  const template = needsElision(cleanTitle) ? titleElided : titleDe;
  return template.replaceAll('{title}', cleanTitle);
};
